import React, { } from 'react';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { Select } from 'antd';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone')
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const { Option } = Select;

export default function ObjectSelectOption(props) {
    const { collection, item, extend, render } = props;
    const dataOptions = collection?.map((i) => {
        let desc = "";
        if (i?.organizatorFederatsiya) {
            desc = "Федерация"
        } else if (i?.organizatorRegionalnoeOtdelenie) {
            desc = "" + i?.organizatorRegionalnoeOtdelenie?.nazvanie
        } else if (i?.organizatorShkola) {
            desc = "" + i?.organizatorShkola?.nazvanieShkoliTantsev
        } else if (i?.organizatorMeropriyatiya) {
            desc = "" + i?.organizatorMeropriyatiya?.nazvanie
        }

        if (i?.meropriyatie) {
            desc += ", " + `${i?.meropriyatie?.nazvanieMeropriyatiya} - ${dayjs(i?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ${(i?.meropriyatie?.mestoProvedeniya) ? "(" + i?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}`
        }
        return (<Option key={i.ID} value={i.ID} label={i.nazvanie /*+ ((i.opisanie && i.opisanie != i.nazvanie) ? " " + i.opisanie : "")*/}>
            <div>
                <span>{i.nazvanie}</span>
                {/* <span>{i.nazvanie}</span> {(i.opisanie && i.opisanie != i.nazvanie) && <span style={{ fontWeight: "lighter" }}>{i.opisanie}</span>} */}
            </div>
            {desc && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                {desc}
            </div>}
        </Option>)
    });
    return dataOptions;
}